module.exports = __webpack_public_path__ + "static/media/loading.f5d5018a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/loading.svg
// module id = 31
// module chunks = 0